import {
    broadcast,
    onBroadcast,
} from "../api"
import App from './App'
import { fireEvent } from '../common/util'
let nativeComponentMap = {}
document.addEventListener('nativeComponentCreated', function(event){
    const { id, instance } = event.param
    nativeComponentMap[id] = instance
})

const Message =  {
    broadcast,
    onBroadcast,
    // 收到父视图发来的消息 父视图调用webview的postMessage方法后，子视图通过该方法监听
    // 由于不支持指定eventName，暂时考虑弃用
    /*onSuperViewEmitMessage(cb) {
        onBroadcast('webviewPostMessage', (event)=>{
            console.log('收到postmessage', event, App, App.rootWebview)
            const { data={} } = event
            if(data.id === App.rootWebview.id){
                cb && cb(data.data)
            }
        })
    },*/
    //收到子视图向父视图发来的消息  onSubViewEmitMessage
    onSubViewEmitMessage(eventName, cb) {
        let subViewMessageCallback = function (event) {
            // console.log('收到EmitMessage onSubViewEmitMessage ===>',event,nativeComponentMap,nativeComponentMap[event.data.id],eventName,event.data.eventName)
            const {data = {}} = event
            if (nativeComponentMap[data.id] && data.id !== App.rootWebviewId && eventName === data.eventName) {
                console.warn('收到指定的 ==》 EmitMessage', event, nativeComponentMap, nativeComponentMap[data.id], eventName, data.eventName)
                cb && cb(data.data)
            }
        };
        onBroadcast('webviewEmitMessage', (event) => {
            subViewMessageCallback(event);
        })
        onBroadcast('MSG_TO_SUPER_VIEW', (event) => {
            subViewMessageCallback(event);
        })
    },
    //向父视图发送消息  emitMessageToSuperView
    emitMessageToSuperView(eventName, params={}) {
        const _params = {
            id: App.rootWebview.id,
            eventName,
            data: {
                ...params
            }
        }
        console.log('emitMessageToSuperView MSG_TO_SUPER_VIEW',_params)
        return Promise.all([
          broadcast('webviewEmitMessage', _params), broadcast('MSG_TO_SUPER_VIEW', _params)
        ])
    },
    //向特定视图发送消息 （使用onSuperViewEmitMessage方法接收消息）
    emitMessageToView(view, eventName, params={}) {
        const _params = {
            id: view.id,
            eventName,
            data: {
                ...params
            }
        }
        return Promise.all([
          broadcast('emitMessageToView', _params), broadcast('MSG_TO_SPECIFIED_VIEW', _params)
        ])
    },
    //收到父视图发来的消息 （接收使用MSG_TO_SPECIFIED_VIEW方法发送的消息）
    onSuperViewEmitMessage(eventName, cb) {
        let superViewMessageCallback = function (event) {
            // console.log(App)
            // const isMe = event.data.id === App.rootWebview.id ? '我的' : '不是我的'
            // const responseStatus = event.data.id === App.rootWebview.id && eventName===event.data.eventName ? '响应' : '不响应'
            // console.log('收到emitMessageToView', isMe, responseStatus, event)
            const {data = {}} = event
            if (data.id === App.rootWebview.id && eventName === data.eventName) {
                cb && cb(data.data)
            }
        };
        onBroadcast('emitMessageToView', (event)=>{
            superViewMessageCallback(event);
        })
        onBroadcast('MSG_TO_SPECIFIED_VIEW', (event)=>{
            superViewMessageCallback(event);
        })
    }

}

// 触发指定view中的js事件 （与onSuperViewEmitMessage方法有所区别，注意区别）
Message.fireViewJsEvent =  (function(){
    Message.onSuperViewEmitMessage('fireViewJsEvent', event=>{
        fireEvent(data.eventName, data.data)
    })

    return function(view, eventName, params={}) {
        const _params = {
            eventName,
            data: {
                ...params
            }
        }
        return Message.emitMessageToView(view, 'fireViewJsEvent', _params)
    }
})()

export default Message